import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "space-y-3" }
const _hoisted_2 = {
  key: 2,
  class: "space-y-3"
}
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = {
  key: 3,
  class: "space-y-3"
}

import { FormSelect, FormInput, FormToggleSm } from "@easy/ui/forms";
import BlockImage from "../BlockImage.vue";
import {
    BlockDefinitionField,
    BlockDefinitionImageField,
    BlockDefinitionSelectField,
    BlockDefinitionSwitchField,
    BlockDefinitionTextField,
} from "@/apps/page/services/blocks/block.interfaces";
import { MediaType } from "@/views/blocks/PageBlock.interface";
import { computed } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupMedia',
  props: {
    fields: {},
    groupData: {}
  },
  setup(__props: any) {



const { t } = useI18n();

const mediaTypeField = computed(
    () => __props.fields.find((f) => f.value === "mediaType") as BlockDefinitionSelectField
);

const imageSrcField = computed(
    () =>
        __props.fields.find((f) => f.value === "src" || f.value === "imageSrc") as BlockDefinitionImageField
);

const imageAltField = computed(
    () =>
        __props.fields.find((f) => f.value === "alt" || f.value === "imageAlt") as BlockDefinitionTextField
);

const videoSrcField = computed(
    () => __props.fields.find((f) => f.value === "videoSrc") as BlockDefinitionTextField
);

const videoAutoplayField = computed(
    () => __props.fields.find((f) => f.value === "videoAutoplay") as BlockDefinitionSwitchField
);

const videoControlsField = computed(
    () => __props.fields.find((f) => f.value === "videoControls") as BlockDefinitionSwitchField
);

const videoLoopField = computed(
    () => __props.fields.find((f) => f.value === "videoLoop") as BlockDefinitionSwitchField
);

const iframeSrcField = computed(
    () => __props.fields.find((f) => f.value === "iframeSrc") as BlockDefinitionTextField
);

const mediaTypeOptions = computed(() => [
    { label: t("page.block.fields.image"), value: MediaType.IMAGE },
    { label: t("page.block.fields.video"), value: MediaType.VIDEO },
    { label: t("page.block.fields.iframe"), value: MediaType.IFRAME },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (mediaTypeField.value)
      ? (_openBlock(), _createBlock(_unref(FormSelect), {
          key: 0,
          id: mediaTypeField.value.value,
          label: mediaTypeField.value.label,
          options: mediaTypeOptions.value,
          modelValue: _ctx.groupData.mediaType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.groupData.mediaType) = $event)),
          value: _ctx.groupData.mediaType || _unref(MediaType).IMAGE
        }, null, 8, ["id", "label", "options", "modelValue", "value"]))
      : _createCommentVNode("", true),
    (!_ctx.groupData.mediaType || _ctx.groupData.mediaType === _unref(MediaType).IMAGE)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(BlockImage, {
            id: imageSrcField.value?.value,
            title: imageSrcField.value?.label,
            modelValue: _ctx.groupData[imageSrcField.value?.value],
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.groupData[imageSrcField.value?.value]) = $event))
          }, null, 8, ["id", "title", "modelValue"]),
          _createVNode(_unref(FormInput), {
            id: imageAltField.value?.value,
            title: imageAltField.value?.label,
            modelValue: _ctx.groupData[imageAltField.value?.value],
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.groupData[imageAltField.value?.value]) = $event))
          }, null, 8, ["id", "title", "modelValue"])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.groupData.mediaType === _unref(MediaType).VIDEO)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(FormInput), {
            id: videoSrcField.value?.value,
            title: videoSrcField.value?.label,
            modelValue: _ctx.groupData[videoSrcField.value?.value],
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.groupData[videoSrcField.value?.value]) = $event)),
            placeholder: "https://"
          }, null, 8, ["id", "title", "modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(FormToggleSm), {
              id: videoAutoplayField.value?.value,
              modelValue: _ctx.groupData[videoAutoplayField.value?.value],
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.groupData[videoAutoplayField.value?.value]) = $event)),
              title: videoAutoplayField.value?.label
            }, null, 8, ["id", "modelValue", "title"]),
            _createVNode(_unref(FormToggleSm), {
              id: videoControlsField.value?.value,
              modelValue: _ctx.groupData[videoControlsField.value?.value],
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.groupData[videoControlsField.value?.value]) = $event)),
              title: videoControlsField.value?.label
            }, null, 8, ["id", "modelValue", "title"]),
            _createVNode(_unref(FormToggleSm), {
              id: videoLoopField.value?.value,
              modelValue: _ctx.groupData[videoLoopField.value?.value],
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.groupData[videoLoopField.value?.value]) = $event)),
              title: videoLoopField.value?.label
            }, null, 8, ["id", "modelValue", "title"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.groupData.mediaType === _unref(MediaType).IFRAME)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(FormInput), {
            id: iframeSrcField.value?.value,
            title: iframeSrcField.value?.label,
            modelValue: _ctx.groupData[iframeSrcField.value?.value],
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.groupData[iframeSrcField.value?.value]) = $event)),
            placeholder: "https://www.youtube.com/embed/LxIR7eFw8HI?si=ObbVhSBAi35VMABl"
          }, null, 8, ["id", "title", "modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})